"use client";

import { useEffect, useState } from "react";
export default function HeroPequeño() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);
  return <section id="hero-pequeño" className="relative h-[60vh] min-h-[400px] w-full overflow-hidden">
      {}
      <div className={`absolute inset-0 bg-cover bg-center transition-transform duration-[5000ms] ease-out ${loaded ? "scale-100" : "scale-105"}`} style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1548683/img/complete_collection_hero_background.png)",
      filter: "blur(1px) brightness(0.85)"
    }} />

      {}
      <div className="absolute inset-0 bg-black/10" />

      {}
      <div className="relative flex h-full items-center justify-center px-6">
        <div className="text-center">
          <h1 className={`font-display text-5xl md:text-6xl lg:text-7xl text-white transition-all duration-[800ms] ease-out ${loaded ? "tracking-wide opacity-100" : "tracking-tight opacity-0"}`}>
            Colección Completa
          </h1>

          {}
          <div className={`mx-auto mt-6 h-[2px] bg-accent transition-all duration-[600ms] delay-[300ms] ease-out ${loaded ? "w-24 opacity-100" : "w-0 opacity-0"}`} />
        </div>
      </div>
    </section>;
}